export const getAuthToken = () => {
	const token = localStorage.getItem('token');
	return token?.trim() ? token.trim() : null;
};

export const getAuthHeaders = (extraHeaders = {}) => {
	const headers = { ...extraHeaders };
	const token = getAuthToken();
	if (token) {
		headers.Authorization = `Bearer ${token}`;
	}
	return headers;
};

export const getUploadAuthHeaders = (extraHeaders = {}) =>
	getAuthHeaders(extraHeaders);
